// Ícone SVG inline da bandeira Credz (sem requisição HTTP)
import * as React from 'react';

export function CredzIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 48 32" role="img" aria-label="Credz" {...props}>
      <rect width="48" height="32" rx="4" fill="#111827" />
      <text
        x="24"
        y="20"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="800"
        fontSize="9"
        fill="#fff"
        letterSpacing="0.3"
      >
        credz
      </text>
      <path d="M36 12l-3 8" stroke="#F43F5E" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
